import Behaviour, { mix, DomEvents } from '@/core'
// import { DomClass } from '@/core/dom'
// import anime from 'animejs'
/**
 *
 * @extends Behaviour
 * @class MobileMenu
 */

export default class SubjectGrid extends mix(Behaviour).with(DomEvents) {
	/**
	 * @function constructor
	 * @param  {HTMLElement} el | the html element the behaviour is mounted on
	 * @return MobileMenu
	 */
	constructor(el) {
		super(el)

		/*
      This function must be called to bind the events
    */
		this.addDomEvents()
	}

	events = {
		'mouseover [data-subject-link]': 'mouseOverLink',
		'mouseout [data-subject-link]': 'mouseOutLink'
	}

	mouseOverLink = (e, $el) => {
		$el.classList.add('-is-hovered')
	}

	mouseOutLink = (e, $el) => {
		$el.classList.remove('-is-hovered')
	}
}
